import { render } from "./PaymentTransaction.vue?vue&type=template&id=090ad604&scoped=true"
import script from "./PaymentTransaction.vue?vue&type=script&lang=js"
export * from "./PaymentTransaction.vue?vue&type=script&lang=js"

import "./PaymentTransaction.vue?vue&type=style&index=0&id=090ad604&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090ad604"]])

export default __exports__